module.exports = __webpack_public_path__ + "img/智慧树.4623d1db.png";